import React, { Component } from "react";
import { setCurrentUserDeclarationAction,postUserDeclarationAction,generateDeclarationDocAction } from 'store/Declaration'
import { requests } from "api/index";
import { connect } from "react-redux";
import URLS from "api/endPoints";


class Declaration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowDeclarationIndex: 0,
      IsAllAreTrue: false,
      disabledPan: false,
      IAuthorizewhatsapp: false,
     AppPanNoliedPanNo: false,
      PanNo: "",
      preferredWhatsappNo: "",
      DeclarationAddress: "",

      IsRelativeWorking: false,
      RelativeNameWorkingInIcici: "",

      IsInterviewedByICICI: false,
      IsInterviewedByICICIText: "",

      IsEmployedByIcici: false,
      IsEmployedByIciciText: "",
      IsEmployedByIciciTextEmp: "",
      
      IsCasePending: false,
      CasePendingDetails: "",

      IsPreviousPendingCase: false,
      PreviousPendingCaseDetails: "",

      IsAnyRelativeDirector: false,
      RelativeDirectorName: "",

       IsClearedCaExam: false,
      CaClearedYear: "",
      CaClearedMonth: "",

      IsAnyCommunicable: false,
      CommunicableDetails: "",



      
    };
  }

  async componentDidMount() {
    this.getDeclaration()
 
  }

  AppliedForPan() {
    this.setState({disabledPan:!this.state.disabledPan})
  }
  
  async getDeclaration() {
    let payload = {
      HCID:this.props.Auth.HCID
    }
  
   await this.props.setCurrentUserDeclarationAction(payload)
   
  }

  submitDeclaration=(e) => {
    e.preventDefault();
    this.setState({ IsAllAreTrue: false });
    
    if(this.state.DeclarationAddress==""){
      alert("Full Address Field Is Required");
      return false
    }
    if(this.preferredWhatsappNo==""){
      alert("Preferred Whatsapp Number Field Is Required");
      return false
    }
    var obj = {
      ResumeID: this.props.Auth.USER_DETAILS_HC.Data[0].ResumeID,
      PanNo: this.state.PanNo || "",
      AppliedPanNo: this.state.disabledPan ? 1 : 0 || 0,
      DeclarationAddress: this.state.DeclarationAddress || "",
      WhatsAppNo: this.state.preferredWhatsappNo || 0,
      AuthorizeWhatsAppCommunication: this.state.IAuthorizewhatsapp ? 1 : 0,
      IsRelativeWorking: this.state.IsRelativeWorking ? 1 : 0,
      // RelativeRelationWorkingInIcici:
      //   this.state.RelativeRelationWorkingInIcici || "",
      RelativeNameWorkingInIcici: this.state.RelativeNameWorkingInIcici || "",
      IsInterviewedByICICI: this.state.IsInterviewedByICICI ? 1 : 0,
      IsEmployedByIciciText:
        this.state.IsEmployedByIciciText +
        "~" +
        this.state.IsEmployedByIciciTextEmp,
      IsInterviewedByICICIText: this.state.IsInterviewedByICICIText,
      IsEmployedByIcici: this.state.IsEmployedByIcici ? 1 : 0,
      IsCasePending: this.state.IsCasePending ? 1 : 0,
      CasePendingDetails: this.state.CasePendingDetails || "",
      IsPreviousPendingCase: this.state.IsPreviousPendingCase ? 1 : 0,
      PreviousPendingCaseDetails: this.state.PreviousPendingCaseDetails || "",
      IsAnyRelativeDirector: this.state.IsAnyRelativeDirector ? 1 : 0,
      RelativeDirectorName: this.state.RelativeDirectorName || "",
      IsClearedCaExam: this.state.IsClearedCaExam ? 1 : 0,
      CaClearedYear: this.state.CaClearedYear || "",
      CaClearedMonth: this.state.CaClearedMonth || "",
      IsAnyCommunicable: this.state.IsAnyCommunicable ? 1 : 0,
      CommunicableDetails: this.state.CommunicableDetails || "",
      candidateno: this.props.Auth.USER_DETAILS_HC.Data[0].CandidateNo,
    };
    this.props.postUserDeclarationAction(obj)

  }
  // async generateDeclarationDoc() {
    
  //   let payload={candidateno:this.props.Auth.USER_DETAILS_HC.Data[0].CandidateNo,}
  //   let res = await generateDeclarationDocAction(payload)
  //   console.log(res)
  // }
  render() {
    return (
      <div>
         <form id="Apllicant-Details" onSubmit={this.submitDeclaration}>

        {this.state.isShowDeclarationIndex === 0 && (
          <card className="rounded-12px drop-shadow20 bg-white block lg:p-8 md:p-8 p-5 lg:mt-12 md:mt-12">
            <div className="lg:px-12 md:px-12 pb-8">
              <h1 className="text-black fsize24 sm-fsize16 font-semibold text-center">
                Undertaking & Declaration
              </h1>

              <p className="line-h30px fsize16 text424B5A mt-4 lg:pr-6 md:pr-6 sm-fsize14">
                With reference to your application for a career opportunity at
                ICICI Bank, this undertaking and declaration seeks information
                and outlines some terms and conditions for employment. All the
                fields in this application are mandatory. Please confirm that
                you have read the clauses below and attest that all the
                information furnished in this application is true and accurate.
                Any misrepresentation of facts, failure to disclose information
                required on this application or material change in information
                provided which is not reported to Human Resources shall be a
                cause for dismissal.
              </p>

              <div className="mt-8 lg:w-4/5 md:w-4/5">
                <label class="custcheckbox">
                  <p className="text424B5A fsize16 line-h28 lg:ml-3 md:ml-3 sm-fsize14 sm-radio-text">
                    The information furnished in the application below is true
                    and accurate. I have read and agree to the terms and
                    conditions mentioned in this application.
                  </p>
                  <input type="checkbox"
                  value={this.state.IsAllAreTrue}
                        onChange={() =>{
                          this.setState({
                            IsAllAreTrue: !this.state.IsAllAreTrue,
                          })
                        }
                        }   /> 
                  <span class="overhide-span"></span>
                </label>
              </div>

              <div className="lg:w-1/3 md:w-1/3 mt-12">
                <div className="mb-4">
                  <div class="form-group  modal-form-cs  mb-4">
                    <label for="">PAN Number</label>
                    {/* <input
                      type="text"
                      placeholder=""
                      className=" fsize16"
                      value="ABD1234567890"
                    /> */}
                    <input
                                type="text"
                                id="DeclarationPanNo"
                                className={
                                  this.state.disabledPan
                                    ? "info-inputdetail cust-bgwhite"
                                    : "info-inputdetail "
                                }
                                
                                value={this.state.PanNo}
                                onChange={(e) =>
                                  this.setState({ PanNo: e.target.value })
                                }
                                disabled={
                                  this.state.disabledPan
                                }
                  />
                  </div>
                  <div>
                   {/* <label class="custcheckbox">
                      <p className="text-black fsize16 line-h28 ml-3">
                        Applied for PAN no.
                      </p>
                      
                      <input
                                  type="checkbox"
                                  id="IsAppliedForPan"
                                  name="IsAppliedForPan"
                                  
                                  checked={this.state.disabledPan == 1}
                                  onChange={() => this.AppliedForPan()}
                                />
                      <span class="overhide-span"></span>
                      </label> */}
                    
                                         <label class="custcheckbox">
                        <p className="text424B5A fsize16 line-h28 ml-3 radio-p-rel">
                          Applied for PAN no.
                        </p>
                        <input
                          type="checkbox"
                          value={this.state.disabledPan}
                          onChange={() => this.AppliedForPan()}
                          //  checked={this.state.disabledPan == true}
                          id="IsAppliedForPan"
                          name="IsAppliedForPan"
                        />
                        <span class="overhide-span"></span>
                      </label>

                    
                  </div>
                    
                  </div>
                   
                <div class="form-group  modal-form-cs  mb-4">
                  <label for="">Address with PIN code</label>
                  {/* {/* <input
                    type="text"
                    placeholder=""
                    className=" fsize16"
                    value="Hyderabad 500032"
                  /> */}
                  
                    <input
                      
                               
                      type="text"
                                className=" fsize16"
                                value={this.state.DeclarationAddress}
                    onChange={(e) => {
                                  this.setState({
                                    DeclarationAddress: e.target.value,
                                  })
                                }
                                }
                      maxLength={500}
                  
                                required />
                </div>

                <div class="form-group  modal-form-cs  mb-4">
                  <label for="">Preferred Whatsapp Number</label>
                  {/* <input
                    type="text"
                    placeholder=""
                  
                    value="+ 91 9123456781"
                  /> */}
                  <input
                                type="text"
                                  className=" fsize16"
                                value={this.state.preferredWhatsappNo}
                    onChange={(e) => {
                                  
                                  this.setState({
                                    preferredWhatsappNo: e.target.value,
                                  })
                    }
                                }
                                maxLength={11}
                                required
                              />
                </div>
              </div>
              <div class="w-full  flex justify-end f-full mt-16 lg:pr-6 md:pr-6">
                <button
                  className="filled-button profiler-btn-w h-47px fsize16 font-semibold rounded-25px"
                  onClick={() =>
                    this.setState({
                      isShowDeclarationIndex: 1,
                    })
                  }
                >
                  PROCEED
                </button>
              </div>
            </div>
          </card>
        )}

        {this.state.isShowDeclarationIndex === 1 && (
          <div>
            <div className="flex justify-center">
              <div className="relative lg:pt-1 pt-4 lg:w-1/6 md:w-1/6 w-3/5	">
                <p className="fsize14 font-semibold mb-3 text-center">
                  Step 1/2{" "}
                  <span className="font-normal ml-3 text-black">
                    Of Declaration
                  </span>
                </p>
                <div className="overflow-hidden h-1 mb-4 text-xs flex rounded bgFAE5D3-transparent">
                  <div
                    style={{ width: "50%", background: "#E87F22" }}
                    className="shadow-none flex flex-col text-center whitespace-nowrap  text-white justify-center bg-amber-500"
                  ></div>
                </div>
              </div>
            </div>

            <card className="rounded-12px drop-shadow20 bg-white block lg:p-8 md:p-8 p-5 lg:mt-6 md:mt-6 sm-shadow-none">
              <div className="lg:px-12 md:px-12 pb-6">
                <div>
                  <h1 className="fsize24 font-bold text262626  sm-fsize16">
                    PART 1: APPLICANT DETAILS
                  </h1>
                  <div className="lg:flex md:flex mt-12">
                    <div className="lg:w-4/6 md:w-4/6 w-full lg:pr-8 md:pr-8">
                      <div className="flex ">
                        <span className="mr-3 fsize18 font-bold">1.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          Do you have any immediate blood relatives-
                          (Parents/Siblings/Spouse/Offspring) working or under
                          consideration for employment at ICICI Bank? If yes,
                          please enter their details.
                        </p>
                      </div>
                    </div>
                    <div className="lg:w-4/12  md:w-4/12  w-full lg:px-0 md:px-0 px-4  lg:pt-0 md:pt-0 pt-4">
                      <div className="flex items-center">
                        <div className="mr-8">
                          {/* <input
                            id="one"
                            class="radio-custom"
                            // name="radio-group"
                            type="radio"
                            checked
                          /> */}
      
                             <input
                            type="radio"
                             id="one"
                            class="radio-custom"
                            name="radio-groupone"
                                    checked={
                                      this.state.IsRelativeWorking === false
                                    }
                                  
                                    value={this.state.IsRelativeWorking}
                            onChange={(e) => {
                                      this.setState({
                                        IsRelativeWorking: !this.state
                                          .IsRelativeWorking,
                                      })
                                    }
                                    }
                                  />
                           
                          <label
                            for="one"
                            class="radio-custom-label fsize16 text-black font-normal"
                          >
                            Yes
                          </label>
                        </div>
                        <div>
                          {/* <input
                            id="two"
                            class="radio-custom"
                            // name="radio-group"
                            type="radio"
                          /> */}
                          
                          <input
                            id="two"
                            class="radio-custom"
                            name="radio-groupone"
                            type="radio"
                            checked={
                                      this.state.IsRelativeWorking === true
                                    }
                                    
                                    value={this.state.IsRelativeWorking}
                            onChange={(e) => {
                                      this.setState({
                                        IsRelativeWorking: !this.state
                                          .IsRelativeWorking,
                                      })}
                                    }
                          />
                          <label
                            for="two"
                            class="radio-custom-label fsize16 text-black font-normal"
                          >
                            No
                          </label>
                        </div>
                      </div>

                      <div className="flex items-center pt-4 ">
                        <div class="form-group modal-form-cs w-1/3 pr-4">
                          <label for="">Parents</label>
                            <select
                               disabled={
                                  this.state.IsRelativeWorking ? "disabled" : ""
                                }
                                className={
                                  this.state.IsRelativeWorking
                                    ? "info-inputdetail cust-bgwhite"
                                    : "info-inputdetail "
                                }
                              >
                              <option
                               
                                value="Male">Mr </option>
                              <option
                               
                                value="Female">Ms</option>
                          </select>
                        </div>
                        <div class="form-group  modal-form-cs  w-2/3">
                          <label for="IsRelativeWorking">Name</label>
                          {/* <input
                            type="text"
                            placeholder=""
                            className="fsize16"
                            value="Michael Ville"
                          /> */}
                               <input
                                type="text"
                                id="IsRelativeWorking"
                                className={
                                  this.state.IsRelativeWorking
                                    ? "info-inputdetail cust-bgwhite"
                                    : "info-inputdetail "
                                }
                                // className="info-inputdetail cust-bgwhite"
                                value={this.state.RelativeNameWorkingInIcici}
                            onChange={(e) => {
                                  this.setState({ RelativeNameWorkingInIcici: e.target.value })}
                                }
                                disabled={
                                  this.state.IsRelativeWorking ? "disabled" : ""
                                }
                  />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="divider-d8d8d8 mt-12"></div>

                  <div className="lg:flex md:flex  lg:mt-10 md:mt-10 mt-6">
                    <div className="lg:w-4/6 md:w-4/6 lg:pr-12 md:pr-12">
                      <div className="flex">
                        <span className="mr-3 fsize18 font-bold">2.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          Have you been interviewed by ICICI Bank in the last 1
                          year? If yes, please enter the details (year
                          /location) in the text field.
                        </p>
                      </div>
                    </div>
                    <div className="lg:w-4/12  md:w-4/12  w-full lg:px-0 md:px-0 px-4  lg:pt-0 md:pt-0 pt-4">
                      <div className="flex items-center">
                        <div className="mr-8">
                          {/* <input
                            id="three"
                            class="radio-custom"
                            // name="radio-group"
                            type="radio"
                            checked
                          /> */}
                           <input
                            type="radio"
                            id="three"
                            class="radio-custom"
                            // name="radio-group"
                                    checked={
                                      this.state.IsInterviewedByICICI === false
                                    }
                                
                                    value={this.state.IsInterviewedByICICI}
                            onChange={(e) => {
                                      this.setState({
                                        IsInterviewedByICICI: !this.state
                                          .IsInterviewedByICICI,
                                      })
                                    }}
                                  />
                          <label
                            for="three"
                            class="radio-custom-label fsize16 text-black font-normal"
                          >
                            Yes
                          </label>
                        </div>
                        <div>
                          {/* <input
                            id="four"
                            class="radio-custom"
                            // name="radio-group"
                            type="radio"
                          /> */}
                          <input
                            type="radio"
                             id="four"
                            class="radio-custom"
                            // name="radio-group"
                                    checked={
                                      this.state.IsInterviewedByICICI === true
                                    }
                                    name="IsInterviewedByICICI"
                                    value={this.state.IsInterviewedByICICI}
                            onChange={(e) => {
                                    
                                      this.setState({
                                        IsInterviewedByICICI: !this.state
                                          .IsInterviewedByICICI,
                                      })}
                                    }
                                  />
                          <label
                            for="four"
                            class="radio-custom-label fsize16 text-black font-normal"
                          >
                            No
                          </label>
                        </div>
                      </div>

                      <div className="flex items-center pt-4 ">
                        <div class="form-group  modal-form-cs w-full ">
                          {/* <input
                            type="text"
                            placeholder=""
                            className="fsize16 pb-12 h-80px"
                            value="Text..."
                          /> */}
                           <input
                                type="text"
                                id="IsInterviewedByICICIText"
                                className={
                                  !this.state.IsInterviewedByICICI
                                    ? "info-inputdetail cust-bgwhite"
                                    : "info-inputdetail "
                                }
                                // className="info-inputdetail cust-bgwhite"
                                value={this.state.IsInterviewedByICICIText}
                            onChange={(e) => {
                                  this.setState({ IsInterviewedByICICIText: e.target.value })}
                                }
                                disabled={
                                  this.state.IsInterviewedByICICI ? "disabled" : ""
                                }
                  />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="divider-d8d8d8 mt-12"></div>

                  <div className="lg:flex md:flex  lg:mt-10 md:mt-10 mt-6">
                    <div className="lg:w-4/6 md:w-4/6 lg:pr-12 md:pr-12">
                      <div className="flex ">
                        <span className="mr-3 fsize18 font-bold">3.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          Have you been employed by ICICI Bank or by ICICI Group
                          Company? If yes, please enter your ICICI employee ID.
                        </p>
                      </div>
                    </div>
                    <div className="lg:w-4/12  md:w-4/12  w-full lg:px-0 md:px-0 px-4  lg:pt-0 md:pt-0 pt-4">
                      <div className="flex items-center">
                        <div className="mr-8">
                          {/* <input
                            id="five"
                            class="radio-custom"
                            // name="radio-group"
                            type="radio"
                            checked
                          /> */}
                           <input
                            type="radio"
                               id="five"
                            class="radio-custom"
                            // name="radio-group"
                                    checked={
                                      this.state.IsEmployedByIcici === false
                                    }
                                
                                    value={this.state.IsEmployedByIcici}
                            onChange={(e) => {
                                      this.setState({
                                        IsEmployedByIcici: !this.state
                                          .IsEmployedByIcici,
                                      })
                                    }}
                                  />
                          <label
                            for="five"
                            class="radio-custom-label fsize16 text-black font-normal"
                          >
                            Yes
                          </label>
                        </div>
                        <div>
                          {/* <input
                            id="six"
                            class="radio-custom"
                            // name="radio-group"
                            type="radio"
                          /> */}
                          <input
                            type="radio"
                                id="six"
                            class="radio-custom"
                            // name="radio-group"
                                    checked={
                                      this.state.IsEmployedByIcici === true
                                    }
                                
                                    value={this.state.IsEmployedByIcici}
                            onChange={(e) => {
                                      this.setState({
                                        IsEmployedByIcici: !this.state
                                          .IsEmployedByIcici,
                                      })
                                    }}
                                  />
                          <label
                            for="six"
                            class="radio-custom-label fsize16 text-black font-normal"
                          >
                            No
                          </label>
                        </div>
                      </div>

                      <div className=" pt-4 ">
                        <div class="form-group  modal-form-cs w-full ">
                          {/* <input
                            type="text"
                            placeholder=""
                            className="fsize16 "
                            value="Test3"
                          /> */}
                                 <input
                                type="text"
                                id="IsEmployedByIciciText"
                                className={
                                  !this.state.IsEmployedByIciciText
                                    ? "info-inputdetail cust-bgwhite"
                                    : "info-inputdetail "
                                }
                                // className="info-inputdetail cust-bgwhite"
                                value={this.state.IsEmployedByIciciText}
                            onChange={(e) => {
                                  this.setState({ IsEmployedByIciciText: e.target.value })}
                                }
                                disabled={
                                  this.state.IsEmployedByIcici ? "disabled" : ""
                                }
                  />
                        </div>
                        <div class="form-group pt-4 modal-form-cs w-full ">
                          <label for="">Employee ID</label>
                          {/* <input
                            type="text"
                            placeholder=""
                            className="fsize16 "
                            value="8787"
                          /> */}
                                       <input
                                type="text"
                                id="IsEmployedByIciciText"
                                className={
                                  !this.state.IsEmployedByIciciTextEmp
                                    ? "info-inputdetail cust-bgwhite"
                                    : "info-inputdetail "
                                }
                                // className="info-inputdetail cust-bgwhite"
                                value={this.state.IsEmployedByIciciTextEmp}
                            onChange={(e) => {
                                  this.setState({ IsEmployedByIciciTextEmp: e.target.value })}
                                }
                                disabled={
                                  this.state.IsEmployedByIcici ? "disabled" : ""
                                }
                  />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="divider-d8d8d8 mt-12"></div>

                  <div className="lg:flex md:flex  lg:mt-10 md:mt-10 mt-6">
                    <div className="lg:w-4/6 md:w-4/6 lg:pr-12 md:pr-12">
                      <div className="flex ">
                        <span className="mr-3 fsize18 font-bold">4.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          Were there any investigations/disciplinary proceedings
                          or any other similar processes related to suspected or
                          alleged misconduct or unsatisfactory performance by
                          your current/former employer(s) initiated against you
                          or is there any ongoing/pending investigations /
                          disciplinary proceedings or any other similar
                          processes related to suspected or alleged misconduct
                          or unsatisfactory performance by your current/former
                          employer (s) initiated against you ? If Yes, please
                          share details below & outcome for the same.
                        </p>
                      </div>
                    </div>
                    <div className="lg:w-4/12  md:w-4/12  w-full lg:px-0 md:px-0 px-4  lg:pt-0 md:pt-0 pt-4">
                      <div className="flex items-center">
                        <div className="mr-8">
                          {/* <input
                            id="seven"
                            class="radio-custom"
                            // name="radio-group"
                            type="radio"
                            checked
                          /> */}
                            <input
                            type="radio"
                               id="seven"
                            class="radio-custom"
                            // name="radio-group"
                                    checked={
                                      this.state.IsCasePending === false
                                    }
                                
                                    value={this.state.IsCasePending}
                            onChange={(e) => {
                                      this.setState({
                                        IsCasePending: !this.state
                                          .IsCasePending,
                                      })
                                    }}
                                  />
                          <label
                            for="seven"
                            class="radio-custom-label fsize16 text-black font-normal"
                          >
                            Yes
                          </label>
                        </div>
                        <div>
                          {/* <input
                            id="eight"
                            class="radio-custom"
                            // name="radio-group"
                            type="radio"
                          /> */}
                          <input
                            type="radio"
                               id="eight"
                            class="radio-custom"
                            // name="radio-group"
                                    checked={
                                      this.state.IsCasePending === true
                                    }
                                
                                    value={this.state.IsCasePending}
                            onChange={(e) => {
                                      this.setState({
                                        IsCasePending: !this.state
                                          .IsCasePending,
                                      })
                                    }}
                                  />
                          <label
                            for="eight"
                            class="radio-custom-label fsize16 text-black font-normal"
                          >
                            No
                          </label>
                        </div>
                      </div>

                      <div className=" pt-4 ">
                        <div class="form-group  modal-form-cs w-full ">
                          {/* <input
                            type="text"
                            placeholder=""
                            className="fsize16 "
                            value="Test4"
                          /> */}
                                             <input
                                type="text"
                                id="CasePendingDetails"
                                className={
                                  !this.state.CasePendingDetails
                                    ? "info-inputdetail cust-bgwhite"
                                    : "info-inputdetail "
                                }
                                // className="info-inputdetail cust-bgwhite"
                                value={this.state.CasePendingDetails}
                            onChange={(e) => {
                                  this.setState({ CasePendingDetails: e.target.value })}
                                }
                                disabled={
                                  this.state.IsCasePending ? "disabled" : ""
                                }
                  />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="divider-d8d8d8 mt-12"></div>

                  <div className="lg:flex md:flex  lg:mt-10 md:mt-10 mt-6">
                    <div className="lg:w-4/6 md:w-4/6 lg:pr-12 md:pr-12">
                      <div className="flex ">
                        <span className="mr-3 fsize18 font-bold">5.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          Do you have any case pending against you in the Court
                          of Law/Police station? Was there any
                          FIR/Investigation/Arrest/Conviction against you in the
                          past? If Yes, please mention the details.
                        </p>
                      </div>
                    </div>
                    <div className="lg:w-4/12  md:w-4/12  w-full lg:px-0 md:px-0 px-4  lg:pt-0 md:pt-0 pt-4">
                      <div className="flex items-center">
                        <div className="mr-8">
                          {/* <input
                            id="nine"
                            class="radio-custom"
                            // name="radio-group"
                            type="radio"
                            checked
                          /> */}
                          <input
                            type="radio"
                               id="nine"
                            class="radio-custom"
                            // name="radio-group"
                                    checked={
                                      this.state.IsPreviousPendingCase === false
                                    }
                                
                                    value={this.state.IsPreviousPendingCase}
                            onChange={(e) => {
                                      this.setState({
                                        IsPreviousPendingCase: !this.state
                                          .IsPreviousPendingCase,
                                      })
                                    }}
                                  />

                          <label
                            for="nine"
                            class="radio-custom-label fsize16 text-black font-normal"
                          >
                            Yes
                          </label>
                        </div>
                        <div>
                          {/* <input
                            id="ten"
                            class="radio-custom"
                            // name="radio-group"
                            type="radio"
                          /> */}
                           <input
                            type="radio"
                               id="ten"
                            class="radio-custom"
                            // name="radio-group"
                                    checked={
                                      this.state.IsPreviousPendingCase === true
                                    }
                                
                                    value={this.state.IsPreviousPendingCase}
                            onChange={(e) => {
                                      this.setState({
                                        IsPreviousPendingCase: !this.state
                                          .IsPreviousPendingCase,
                                      })
                                    }}
                                  />
                          
                          <label
                            for="ten"
                            class="radio-custom-label fsize16 text-black font-normal"
                          >
                            No
                          </label>
                        </div>
                      </div>

                      <div className=" pt-4 ">
                        <div class="form-group  modal-form-cs w-full ">
                          {/* <input
                            type="text"
                            placeholder=""
                            className="fsize16 "
                            value="Test5"
                          /> */}
                                             <input
                                type="text"
                                id="IsEmployedByIciciText"
                                className={
                                  !this.state.PreviousPendingCaseDetails
                                    ? "info-inputdetail cust-bgwhite"
                                    : "info-inputdetail "
                                }
                                // className="info-inputdetail cust-bgwhite"
                                value={this.state.PreviousPendingCaseDetails}
                            onChange={(e) => {
                                  this.setState({ PreviousPendingCaseDetails: e.target.value })}
                                }
                                disabled={
                                  this.state.IsPreviousPendingCase ? "disabled" : ""
                                }
/>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="divider-d8d8d8 mt-12"></div>

                  <div className="lg:flex md:flex  lg:mt-10 md:mt-10 mt-6">
                    <div className="lg:w-4/6 md:w-4/6 lg:pr-12 md:pr-12">
                      <div className="flex ">
                        <span className="mr-3 fsize18 font-bold">6.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          Are you related to any Director of ICICI Bank/ ICICI
                          Group Company?
                        </p>
                      </div>
                    </div>
                    <div className="lg:w-4/12  md:w-4/12  w-full lg:px-0 md:px-0 px-4  lg:pt-0 md:pt-0 pt-4">
                      <div className="flex items-center">
                        <div className="mr-8">
                          {/* <input
                            id="question12"
                            class="radio-custom"
                            // name="radio-group"
                            type="radio"
                            checked
                          /> */}
                            <input
                            type="radio"
                               id="question12"
                            class="radio-custom"
                            // name="radio-group"
                                    checked={
                                      this.state.IsAnyRelativeDirector === false
                                    }
                                
                                    value={this.state.IsAnyRelativeDirector}
                            onChange={(e) => {
                                      this.setState({
                                        IsAnyRelativeDirector: !this.state
                                          .IsAnyRelativeDirector,
                                      })
                                    }}
                                  />
                          <label
                            for="question12"
                            class="radio-custom-label fsize16 text-black font-normal"
                          >
                            Yes
                          </label>
                        </div>
                        <div>
                          {/* <input
                            id="question13"
                            class="radio-custom"
                            // name="radio-group"
                            type="radio"
                          /> */}
                             <input
                            type="radio"
                               id="question13"
                            class="radio-custom"
                            // name="radio-group"
                                    checked={
                                      this.state.IsAnyRelativeDirector === true
                                    }
                                
                                    value={this.state.IsAnyRelativeDirector}
                            onChange={(e) => {
                                      this.setState({
                                        IsAnyRelativeDirector: !this.state
                                          .IsAnyRelativeDirector,
                                      })
                                    }}
                                  />
                          <label
                            for="question13"
                            class="radio-custom-label fsize16 text-black font-normal"
                          >
                            No
                          </label>
                        </div>
                      </div>

                      <div className=" pt-4 ">
                        <div class="form-group  modal-form-cs w-full ">
                          {/* <input
                            type="text"
                            placeholder=""
                            className="fsize16 "
                            value="Test6"
                          /> */}
                                             <input
                                type="text"
                                id="RelativeDirectorName"
                                className={
                                  !this.state.RelativeDirectorName
                                    ? "info-inputdetail cust-bgwhite"
                                    : "info-inputdetail "
                                }
                                // className="info-inputdetail cust-bgwhite"
                                value={this.state.RelativeDirectorName}
                            onChange={(e) => {
                                  this.setState({ RelativeDirectorName: e.target.value })}
                                }
                                disabled={
                                  this.state.IsAnyRelativeDirector ? "disabled" : ""
                                }
/>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="divider-d8d8d8 mt-12"></div>

                  <div className="lg:flex md:flex  lg:mt-10 md:mt-10 mt-6">
                    <div className="lg:w-4/6 md:w-4/6 lg:pr-12 md:pr-12">
                      <div className="flex ">
                        <span className="mr-3 fsize18 font-bold">7.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          Have you cleared CA examination in your first
                          appearance, both groups taken together, in a single
                          sitting? (Applicable only to Chartered Accountants)
                        </p>
                      </div>
                    </div>
                    <div className="lg:w-4/12  md:w-4/12  w-full lg:px-0 md:px-0 px-4  lg:pt-0 md:pt-0 pt-4">
                      <div className="flex items-center">
                        <div className="mr-8">
                          {/* <input
                            id="question14"
                            class="radio-custom"
                            // name="radio-group"
                            type="radio"
                            checked
                          /> */}
                           <input
                            type="radio"
                               id="question14"
                            class="radio-custom"
                            // name="radio-group"
                                    checked={
                                      this.state.IsClearedCaExam === false
                                    }
                                
                                    value={this.state.IsClearedCaExam}
                            onChange={(e) => {
                                      this.setState({
                                        IsClearedCaExam: !this.state
                                          .IsClearedCaExam,
                                      })
                                    }}
                                  />
                          <label
                            for="question14"
                            class="radio-custom-label fsize16 text-black font-normal"
                          >
                            Yes
                          </label>
                        </div>
                        <div>
                          {/* <input
                            id="question15"
                            class="radio-custom"
                            // name="radio-group"
                            type="radio"
                          /> */}
                          <input
                            type="radio"
                               id="question15"
                            class="radio-custom"
                            // name="radio-group"
                                    checked={
                                      this.state.IsClearedCaExam === true
                                    }
                                
                                    value={this.state.IsClearedCaExam}
                            onChange={(e) => {
                                      this.setState({
                                        IsClearedCaExam: !this.state
                                          .IsClearedCaExam,
                                      })
                                    }}
                                  />
                          <label
                            for="question15"
                            class="radio-custom-label fsize16 text-black font-normal"
                          >
                            No
                          </label>
                        </div>
                      </div>

                      <div className=" pt-4 ">
                        <div className="flex items-center  ">
                          <div class="form-group modal-form-cs w-1/2 pr-2">
                            <label for="">Month</label>
                              <select
                                  className={
                                  !this.state.CaClearedYear
                                    ? "info-inputdetail cust-bgwhite"
                                    : "info-inputdetail "
                                }
                                disabled={
                                  this.state.IsClearedCaExam ? "disabled" : ""
                                }
                                >
                              <option    value="Male">June </option>
                              <option value="Female">Jult</option>
                            </select>
                          </div>
                          <div class="form-group  modal-form-cs  w-1/2 pl-2">
                            <label for="">Year</label>
                            {/* <input
                              type="date"
                              placeholder=""
                              className="fsize16"
                              value="Year"
                            /> */}
                                               <input
                                 type="date"
                                id="CaClearedYear"
                                className={
                                  !this.state.CaClearedYear
                                    ? "info-inputdetail cust-bgwhite"
                                    : "info-inputdetail "
                                }
                                // className="info-inputdetail cust-bgwhite"
                                value={this.state.CaClearedYear}
                            onChange={(e) => {
                                  this.setState({CaClearedYear: e.target.value })}
                                }
                                disabled={
                                  this.state.IsClearedCaExam ? "disabled" : ""
                                }
                  />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="divider-d8d8d8 mt-12"></div>

                  <div className="lg:flex md:flex  lg:mt-10 md:mt-10 mt-6">
                    <div className="lg:w-4/6 md:w-4/6 lg:pr-12 md:pr-12">
                      <div className="flex ">
                        <span className="mr-3 fsize18 font-bold">8.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          Do you have any communicable/ contagious diseases (An
                          infectious disease transmissible by direct contact
                          with an affected individual)? Do you have any
                          injury/medical condition that can be aggravated by
                          tasks and responsibilities assigned during the course
                          of employment? If Yes, please give details.
                        </p>
                      </div>
                    </div>
                    <div className="lg:w-4/12  md:w-4/12  w-full lg:px-0 md:px-0 px-4  lg:pt-0 md:pt-0 pt-4">
                      <div className="flex items-center">
                        <div className="mr-8">
                          {/* <input
                            id="question17"
                            class="radio-custom"
                            // name="radio-group"
                            type="radio"
                            checked
                          /> */}
                             <input
                            type="radio"
                               id="question17"
                            class="radio-custom"
                            // name="radio-group"
                                    checked={
                                      this.state.IsAnyCommunicable === false
                                    }
                                
                                    value={this.state.IsAnyCommunicable}
                            onChange={(e) => {
                                      this.setState({
                                        IsAnyCommunicable: !this.state
                                          .IsAnyCommunicable,
                                      })
                                    }}
                                  />
                          <label
                            for="question17"
                            class="radio-custom-label fsize16 text-black font-normal"
                          >
                            Yes
                          </label>
                        </div>
                        <div>
                          {/* <input
                            id="question18"
                            class="radio-custom"
                            // name="radio-group"
                            type="radio"
                          /> */}
                             <input
                            type="radio"
                               id="question18"
                            class="radio-custom"
                            // name="radio-group"
                                    checked={
                                      this.state.IsAnyCommunicable === true
                                    }
                                
                                    value={this.state.IsAnyCommunicable}
                            onChange={(e) => {
                                      this.setState({
                                        IsAnyCommunicable: !this.state
                                          .IsAnyCommunicable,
                                      })
                                    }}
                                  />
                          <label
                            for="question18"
                            class="radio-custom-label fsize16 text-black font-normal"
                          >
                            No
                          </label>
                        </div>
                      </div>

                      <div className=" pt-4 ">
                        <div class="form-group  modal-form-cs w-full ">
                          {/* <input
                            type="text"
                            placeholder=""
                            className="fsize16 "
                            value="Test8"
                          /> */}
                                             <input
                                type="text"
                                id="CommunicableDetails"
                                className={
                                  !this.state.CommunicableDetails
                                    ? "info-inputdetail cust-bgwhite"
                                    : "info-inputdetail "
                                }
                                // className="info-inputdetail cust-bgwhite"
                                value={this.state.CommunicableDetails}
                            onChange={(e) => {
                                  this.setState({ CommunicableDetails: e.target.value })}
                                }
                                disabled={
                                  this.state.IsAnyCommunicable ? "disabled" : ""
                                }
                  />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-full  flex justify-end f-full  lg:mt-20 md:mt-20 mt-16 lg:pr-6  md:pr-6 ">
                  <button
                    className="filled-button w-230px h-47px fsize16 font-semibold rounded-25px   sm-fsize14  profiler-btn-w"
                    onClick={() =>
                      this.setState({
                        isShowDeclarationIndex: 2,
                      })
                    }
                  >
                    SAVE & PROCEED
                  </button>
                </div>
              </div>
            </card>
          </div>
        )}

        {this.state.isShowDeclarationIndex === 2 && (
          <div>
            <div className="flex justify-center">
              <div className="relative lg:pt-1 pt-4 lg:w-1/6 md:w-1/6 w-3/5">
                <p className="fsize14 font-semibold mb-3 text-center">
                  Step 1/2{" "}
                  <span className="font-normal ml-3 text-black">
                    Of Declaration
                  </span>
                </p>
                <div className="overflow-hidden h-1 mb-4 text-xs flex rounded bgFAE5D3-transparent">
                  <div
                    style={{ width: "50%", background: "#E87F22" }}
                    className="shadow-none flex flex-col text-center whitespace-nowrap  text-white justify-center bg-amber-500"
                  ></div>
                </div>
              </div>
            </div>
            <card className="rounded-12px drop-shadow20 bg-white block lg:p-8 md:p-8 p-5 lg:mt-6 md:mt-6 sm-shadow-none">
              <div className="lg:px-12 md:px-12 pb-6">
                <div>
                  <h1 className="fsize24 font-bold text262626  sm-fsize16">
                    PART 2: DECLARATION & AUTHORIZATION
                  </h1>
                  <div className="mt-10">
                    <h1 className="fsize20 font-bold sm-fsize14">
                      DECLARATION
                    </h1>
                    <div className="mt-8">
                      <div className="flex mb-8">
                        <span className="mr-1 fsize18 ">9.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          I declare that the information in this declaration and
                          in any other documents completed by me / and or other
                          statement made by me in support of my application for
                          employment with ICICI Bank and the information
                          furnished by me with respect to my previous
                          employment/s, compensation and qualification is true
                          and correct in every detail.
                        </p>
                      </div>

                      <div className="flex mb-8">
                        <span className="mr-1 fsize18 ">10.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          I further declare that I am and was never a member of
                          any banned outfits declared by the Government.
                        </p>
                      </div>

                      <div className="flex mb-8">
                        <span className="mr-1 fsize18 ">11.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          I understand if an offer for employment with ICICI
                          Bank is made, it has been made basis the information
                          that I have provided in my application. I am further
                          aware that my appointment and continuation in
                          employment is subject to successful completion of my
                          graduation/post-graduation, as applicable and
                          submission of graduation/post-graduation certificates
                          and mark sheets within 3 months from the date of
                          joining.
                        </p>
                      </div>

                      <div className="flex mb-8">
                        <span className="mr-1 fsize18 ">12.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          I understand that my role in ICICI Bank would also be
                          a sales role and I may be required to travel
                          extensively as per the requirement of my job/role, as
                          may be needed for the exigencies of the Bank.
                        </p>
                      </div>

                      <div className="flex mb-8">
                        <span className="mr-1 fsize18 ">13.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          I further understand that my services in the Bank are
                          transferrable in any location and profile across the
                          country as per the organization requirements.
                        </p>
                      </div>

                      <div className="flex mb-8">
                        <span className="mr-1 fsize18 ">14.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          I am aware that in case of any misrepresentation,
                          false statement, discrepancies found out by ICICI Bank
                          at a later date on any of the above declarations made
                          by me, my candidature as well as subsequent
                          continuation of employment with ICICI Bank- as the
                          case may be- will be liable to be cancelled/revoked
                          and or terminated, at any time, without assigning any
                          reason thereof and I shall be bound by any such
                          decision of the Bank. The same will amount to
                          misconduct and render the applicant liable to
                          disciplinary action including termination of
                          employment.
                        </p>
                      </div>

                      <div className="flex mb-8">
                        <span className="mr-1 fsize18 ">15.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          I understand that any employment by ICICI Bank or its
                          affiliated companies is conditioned upon positive
                          responses from my references, continued adherence to
                          ICICI Bank policies and procedures, applicable rules
                          and regulations and job performance satisfactory at
                          all times. I consent to take any pre or
                          post-employment examinations as may be required by
                          ICICI Bank or its representative, and release ICICI
                          Bank any liability that may arise from such
                          examination.
                        </p>
                      </div>

                      <div className="flex ">
                        <span className="mr-1 fsize18 ">16.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          I shall abide by the above terms of my employment
                        </p>
                      </div>

                      <h1 className="font-bold text-black mt-12 mb-8 fsize20   sm-fsize14">
                        AUTHORIZATION:
                      </h1>
                      <div className="flex mb-8">
                        <span className="mr-1 fsize18 ">17.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          I authorize ICICI Bank to procure my credit
                          information from TransUnion CIBIL Ltd. or from any
                          other recognized credit information company.
                        </p>
                      </div>

                      <div className="flex mb-8">
                        <span className="mr-1 fsize18 ">18.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          I agree for pre-employment checks as deemed necessary
                          and hereby authorize ICICI Bank and it agents,
                          representatives, consultants, service providers to
                          conduct pre-employment checks, including an inquiry
                          into all the information contained in this application
                          including an inquiry with former employers and
                          officials of education institutes and self-declared
                          addresses. I further authorize former employers and
                          officials of education institutes to give information
                          about me and my education credentials and I release
                          them from all liability for issuing such information.
                        </p>
                      </div>
                      <div className="flex mb-8">
                        <span className="mr-1 fsize18 ">19.</span>
                        <p className="fsize18 text-black line-h30 sm-fsize14">
                          I authorize ICICI Bank to verify disciplinary /
                          compliance related issues from my current/former
                          employers.
                        </p>
                      </div>
                    </div>

                    <div className="mt-12">
                      <div className="flex items-center mb-1">
                        <h1 className="fsize18 font-bold sm-fsize14">
                            Applicant Name :
                            {/* Mobile DOB CreatedOn this.props.Auth.user.USER_DETAILS_HC.Data.CandidateName */}
                        </h1>
                        <p className="fsize18 pl-1 sm-fsize14">
                        {this.props.Auth && this.props.Auth.USER_DETAILS_HC && this.props.Auth.USER_DETAILS_HC.Data[0] ? this.props.Auth.USER_DETAILS_HC.Data[0].CandidateName:""}
                        </p>
                      </div>

                      <div className="flex items-center mb-1">
                        <h1 className="fsize18 font-bold sm-fsize14">
                          Contact No :
                        </h1>
                        <p className="fsize18 pl-1 sm-fsize14">{this.props.Auth && this.props.Auth.USER_DETAILS_HC && this.props.Auth.USER_DETAILS_HC.Data[0] ? this.props.Auth.USER_DETAILS_HC.Data[0].Mobile:""}</p>
                      </div>

                      <div className="flex items-center mb-1">
                        <h1 className="fsize18 font-bold sm-fsize14">
                          Date of Birth :{" "}
                        </h1>
                        <p className="fsize18 pl-1 sm-fsize14">23-10-1990</p>
                      </div>

                      <div className="flex items-center mb-1">
                        <h1 className="fsize18 font-bold sm-fsize14">
                          Date :{" "}
                        </h1>
                        <p className="fsize18 pl-1 sm-fsize14">8-06-2021</p>
                      </div>
                    </div>

                    <div class="w-full  flex justify-end f-full  lg:mt-20 md:mt-20 mt-16 lg:pr-6  md:pr-6 ">
                      <button className="filled-button w-230px h-47px fsize16 font-semibold rounded-25px   sm-fsize14  profiler-btn-w">
                        SUBMIT
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
          )}
          </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  
  return {
    Auth: state.Auth.user,
    
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentUserDeclarationAction: async (payload) => {
      await dispatch(setCurrentUserDeclarationAction(payload));
    },
    
    postUserDeclarationAction: async (payload) => {
      await dispatch(postUserDeclarationAction(payload));
    },
    generateDeclarationDocAction: async (payload) => {
      await dispatch(generateDeclarationDocAction(payload));
    },
    
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Declaration);


